import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization_delete_data`;

export function deleteDonationPayment(orgId) {
  return axios.delete(`${URL}/donation_payment/${orgId}`);
}

export function donationConfirmation(orgId) {
  return axios.delete(`${URL}/donation_confirmation/${orgId}`);
}

export function donationListImport(orgId) {
  return axios.delete(`${URL}/donation_list_import/${orgId}`);
}

export function donationImport(orgId) {
  return axios.delete(`${URL}/donation_import/${orgId}`);
}

export function donationItem(orgId) {
  return axios.delete(`${URL}/donation_item/${orgId}`);
}

export function donationLog(orgId) {
  return axios.delete(`${URL}/donation_log/${orgId}`);
}

export function donation(orgId) {
  return axios.delete(`${URL}/donation/${orgId}`);
}

export function orgFile(orgId) {
  return axios.delete(`${URL}/organization_file/${orgId}`);
}

export function orgReport(orgId) {
  return axios.delete(`${URL}/organization_report/${orgId}`);
}

export function file(orgId) {
  return axios.delete(`${URL}/file/${orgId}`);
}

export function projectProgram(orgId) {
  return axios.delete(`${URL}/project_program/${orgId}`);
}

export function projectIncome(orgId) {
  return axios.delete(`${URL}/project_income/${orgId}`);
}

export function projectFile(orgId) {
  return axios.delete(`${URL}/project_file/${orgId}`);
}

export function projectExpense(orgId) {
  return axios.delete(`${URL}/project_expense/${orgId}`);
}

export function project(orgId) {
  return axios.delete(`${URL}/project/${orgId}`);
}

export function program(orgId) {
  return axios.delete(`${URL}/program/${orgId}`);
}

export function fundType(orgId) {
  return axios.delete(`${URL}/fund_type/${orgId}`);
}

export function echannelStatement(orgId) {
  return axios.delete(`${URL}/echannel_statement/${orgId}`);
}

export function bankTrx(orgId) {
  return axios.delete(`${URL}/bank_trx/${orgId}`);
}

export function bankStatement(orgId) {
  return axios.delete(`${URL}/bank_statement/${orgId}`);
}

export function bankImport(orgId) {
  return axios.delete(`${URL}/bank_import/${orgId}`);
}

export function bankPooling(orgId) {
  return axios.delete(`${URL}/bank_pooling/${orgId}`);
}

export function paymentMethod(orgId) {
  return axios.delete(`${URL}/payment_method/${orgId}`);
}

export function paymentGateway(orgId) {
  return axios.delete(`${URL}/payment_gateway/${orgId}`);
}

export function bankAccount(orgId) {
  return axios.delete(`${URL}/bank_account/${orgId}`);
}

export function bank(orgId) {
  return axios.delete(`${URL}/bank/${orgId}`);
}

export function donorLog(orgId) {
  return axios.delete(`${URL}/donor_log/${orgId}`);
}

export function donor(orgId) {
  return axios.delete(`${URL}/donor/${orgId}`);
}

export function donorCategory(orgId) {
  return axios.delete(`${URL}/donor_category/${orgId}`);
}
